export default __webpack_public_path__ + "static/media/ic_delete_24px.82438203.svg";